import { render, staticRenderFns } from "./ErrorBoundary.vue?vue&type=template&id=1bea8424&"
import script from "./ErrorBoundary.vue?vue&type=script&lang=js&"
export * from "./ErrorBoundary.vue?vue&type=script&lang=js&"
import style0 from "./ErrorBoundary.vue?vue&type=style&index=0&id=1bea8424&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports